import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const SearchHeader = ({ 
  searchQuery, 
  onSearchChange, 
  onSearch, 
  totalResults, 
  searchTime,
  onSaveSearch,
  onExportResults 
}) => {
  const [showSaveDialog, setShowSaveDialog] = useState(false);
  const [savedSearchName, setSavedSearchName] = useState('');

  const handleSaveSearch = () => {
    if (savedSearchName?.trim()) {
      onSaveSearch(savedSearchName?.trim());
      setSavedSearchName('');
      setShowSaveDialog(false);
    }
  };

  const suggestedQueries = [
    "Find all policy documents updated in the last 30 days",
    "Show me safety procedures for manufacturing",
    "Documents containing compliance requirements",
    "Training materials for new employees"
  ];

  return (
    <div className="bg-background border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* Search Input */}
        <div className="mb-6">
          <form onSubmit={onSearch} className="relative max-w-4xl">
            <Input
              type="search"
              placeholder="Search documents using natural language..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="w-full pl-12 pr-20 py-4 text-lg"
            />
            <Icon 
              name="Search" 
              size={24} 
              className="absolute left-4 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
            />
            <Button
              type="submit"
              variant="default"
              className="absolute right-2 top-1/2 transform -translate-y-1/2"
              iconName="Search"
              iconSize={18}
            >
              Search
            </Button>
          </form>
        </div>

        {/* Search Results Summary */}
        {totalResults > 0 && (
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4">
            <div className="flex items-center gap-4">
              <p className="text-sm text-muted-foreground">
                Found <span className="font-medium text-foreground">{totalResults?.toLocaleString()}</span> results
                {searchTime && (
                  <span className="ml-2">in {searchTime}ms</span>
                )}
              </p>
              <div className="flex items-center gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => setShowSaveDialog(true)}
                  iconName="Bookmark"
                  iconSize={16}
                >
                  Save Search
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={onExportResults}
                  iconName="Download"
                  iconSize={16}
                >
                  Export Results
                </Button>
              </div>
            </div>
          </div>
        )}

        {/* Suggested Queries */}
        {!searchQuery && (
          <div className="mb-4">
            <p className="text-sm font-medium text-foreground mb-3">Try these searches:</p>
            <div className="flex flex-wrap gap-2">
              {suggestedQueries?.map((query, index) => (
                <Button
                  key={index}
                  variant="outline"
                  size="sm"
                  onClick={() => onSearchChange(query)}
                  className="text-xs"
                >
                  {query}
                </Button>
              ))}
            </div>
          </div>
        )}

        {/* Save Search Dialog */}
        {showSaveDialog && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-card border border-border rounded-lg p-6 w-full max-w-md mx-4">
              <h3 className="text-lg font-semibold text-card-foreground mb-4">Save Search</h3>
              <Input
                label="Search Name"
                placeholder="Enter a name for this search"
                value={savedSearchName}
                onChange={(e) => setSavedSearchName(e?.target?.value)}
                className="mb-4"
              />
              <div className="flex justify-end gap-3">
                <Button
                  variant="outline"
                  onClick={() => setShowSaveDialog(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="default"
                  onClick={handleSaveSearch}
                  disabled={!savedSearchName?.trim()}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchHeader;